(function () {
  if (window.__mpnQtyTrash) return; window.__mpnQtyTrash = true;
  var LABEL = window.__mpnQtyTrashLabel;
  var ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>';
  var SCOPE = 'cart-items, cart-drawer-items';

  function cartInput(qi) {
    if (!qi || !qi.closest || !qi.closest(SCOPE)) return null;
    var input = qi.querySelector('input.quantity__input[data-index]');
    return input || null;
  }
  /* Au minimum si un « − » ferait passer sous le minimum de la ligne (regle de quantite data-min, pas = step). */
  function atMin(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) return false;
    var min = Math.max(parseInt(input.dataset.min, 10) || 1, 1);
    var step = parseInt(input.step, 10) || 1;
    return v <= min || v - step < min;
  }
  function apply(qi) {
    var input = cartInput(qi);
    if (!input) return;
    var btn = qi.querySelector('.quantity__button[name="minus"]');
    if (!btn) return;
    if (!btn.querySelector('.mpn-qt-ico')) {
      var s = document.createElement('span');
      s.className = 'mpn-qt-ico';
      s.innerHTML = ICON;
      btn.appendChild(s);
    }
    var on = atMin(input);
    if (on === btn.classList.contains('mpn-qt-trash')) return;
    btn.classList.toggle('mpn-qt-trash', on);
    if (on) btn.setAttribute('aria-label', LABEL); else btn.removeAttribute('aria-label');
  }
  /* Minimum de commande (oct. 2026, demande d'Ed) : si une ligne est sous son minimum (message
     [data-mpn-moq-warn] rendu par snippets/mpn-moq-cart.liquid), « Commander » et les paiements express sont bloques. */
  function guard() {
    var bad = !!document.querySelector('cart-items [data-mpn-moq-warn], cart-drawer-items [data-mpn-moq-warn], #main-cart-items [data-mpn-moq-warn], #CartDrawer [data-mpn-moq-warn]');
    document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout').forEach(function (b) {
      if (bad) { if (!b.disabled) { b.disabled = true; b.setAttribute('data-mpn-moq-off', ''); } }
      else if (b.hasAttribute('data-mpn-moq-off')) { b.disabled = false; b.removeAttribute('data-mpn-moq-off'); }
    });
    document.documentElement.classList.toggle('mpn-moq-block', bad);
  }
  /* Ligne sous son minimum (ex. 1 piece ajoutee hors fiche produit) : remontee automatique au minimum (choix d'Ed),
     via le changement de quantite normal du theme (meme rendu qu'un clic sur « + »). Une seule tentative par valeur. */
  var bumped = {};
  function bump() {
    document.querySelectorAll('cart-items input.quantity__input[data-index], cart-drawer-items input.quantity__input[data-index]').forEach(function (inp) {
      var min = parseInt(inp.dataset.min, 10) || 1;
      var v = parseInt(inp.value, 10);
      if (min < 2 || !(v > 0) || v >= min) return;
      var k = (inp.closest('cart-drawer-items') ? 'd' : 'p') + inp.dataset.index + ':' + (inp.dataset.quantityVariantId || '') + ':' + v;
      if (bumped[k]) return; bumped[k] = 1;
      inp.value = min;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function applyAll() {
    document.querySelectorAll('cart-items quantity-input, cart-drawer-items quantity-input').forEach(apply);
    guard();
    bump();
  }

  /* Clic sur la corbeille : intercepte avant le gestionnaire du theme (phase de capture).
     Uniquement le bouton « − » d'une ligne du panier (cart-items / cart-drawer-items) ET au minimum ;
     tout autre clic (icone panier, liens, autres boutons) n'est jamais touche. */
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || t.nodeType !== 1 || !t.closest) return;
      var btn = t.closest('button.quantity__button[name="minus"]');
      if (!btn || !btn.closest(SCOPE)) return;
      var qi = btn.closest('quantity-input');
      var input = cartInput(qi);
      if (!input || !atMin(input)) return;
      var line = input.dataset.index;
      var row = btn.closest('.cart-item');
      var rb = (row && row.querySelector('cart-remove-button')) ||
        document.getElementById('CartDrawer-Remove-' + line) || document.getElementById('Remove-' + line);
      var items = btn.closest(SCOPE);
      if (!rb && !(items && typeof items.updateQuantity === 'function')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (rb) { rb.click(); return; }
      items.updateQuantity(line, 0);
    } catch (err) {}
  }, true);

  /* Saisie au clavier ou + / − : met a jour l'icone tout de suite. */
  ['input', 'change'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      try {
        var qi = e.target && e.target.closest && e.target.closest('quantity-input');
        if (qi) apply(qi);
      } catch (err) {}
    }, true);
  });

  /* Re-rendu du tiroir / de la page panier : on re-applique. */
  var queued = false;
  function schedule() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; try { applyAll(); } catch (err) {} });
  }
  function start() {
    try { applyAll(); } catch (err) {}
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
